import React from "react";

interface TasksGroupsProps {
  title: string;
  children: React.ReactNode;
}
export const TasksGroups = React.forwardRef(({ title, children }: TasksGroupsProps, ref: any) => {
  return (
    <div ref={ref} className="md:col-span-4 col-span-12">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      {children}
    </div>
  );
});
